import React from 'react';
import {TaskRowHeaderV2 as TaskRowHeaderComponentV2} from '@/web-components';
import * as tracking from '../../../../../tracking';

// showNovaColumn is computed once by the caller (Task_list.js) and passed to both this header
// and every row — the header and rows must never derive it independently, or their Nova cell
// widths can disagree and misalign every column after it.
const TaskListHeader = ({intl, enabledColumns, sortBy, onSortByChange, stickyTopPosition, isInContainer, showNovaColumn}) => {
	return (
		<TaskRowHeaderComponentV2
			intl={intl}
			columns={enabledColumns}
			sortBy={sortBy}
			onSortByChange={onSortByChange}
			stickyTopPosition={stickyTopPosition}
			isInContainer={isInContainer}
			tracking={tracking}
			showNovaColumn={showNovaColumn}
		/>
	);
};

export default TaskListHeader;
